export type Breakpoint =
  | 'sm'
  | 'md'
  | 'lg'
  | 'xl'
  | 'xxl'
  | 'miniTablet'
  | 'tablet'
  | 'desktop'
  | 'largeDesktop'
  | 'mobileOnly'
  | 'miniTabletOnly'
  | 'tabletOnly'
  | 'desktopOnly';

export const mediaQueries: Record<Breakpoint, string> = {
  /* legacy: */
  sm: '(min-width: 640px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 1024px)',
  xl: '(min-width: 1280px)',
  xxl: '(min-width: 1536px)',
  /* CASCADING QUERIES: */
  miniTablet: '(min-width: 530px)',
  tablet: '(min-width: 768px)',
  desktop: '(min-width: 1024px)',
  largeDesktop: '(min-width: 1200px)',
  /* restrictive queries: */
  mobileOnly: '(max-width: 529px)',
  miniTabletOnly: '(min-width: 530px) and (max-width: 767px)',
  tabletOnly: '(min-width: 768px) and (max-width: 1023px)',
  desktopOnly: '(min-width: 1024px) and (max-width: 1199px)',
  /* IMPORTANT: Whenever the breakpoints are modified here, but also mirror the change in
  tools/config/tailwind/plugins/stihl-web-style-guide-mappings.plugin.js */
};

export type ContainerSize = 'miniTablet' | 'tablet' | 'desktop' | 'largeDesktop';

const MINI_TABLET_CONTAINER_QUERY_VALUE = 530;
const TABLET_CONTAINER_QUERY_VALUE = 767;
const DESKTOP_CONTAINER_QUERY_VALUE = 1024;
const LARGE_DESKTOP_CONTAINER_QUERY_VALUE = 1200;

export const containerQueryValues: Record<ContainerSize, number> = {
  miniTablet: MINI_TABLET_CONTAINER_QUERY_VALUE,
  tablet: TABLET_CONTAINER_QUERY_VALUE,
  desktop: DESKTOP_CONTAINER_QUERY_VALUE,
  largeDesktop: LARGE_DESKTOP_CONTAINER_QUERY_VALUE,
};
export const containerQueries: Record<ContainerSize, string> = {
  miniTablet: `${MINI_TABLET_CONTAINER_QUERY_VALUE}px`,
  tablet: `${TABLET_CONTAINER_QUERY_VALUE}px`,
  desktop: `${DESKTOP_CONTAINER_QUERY_VALUE}px`,
  largeDesktop: `${LARGE_DESKTOP_CONTAINER_QUERY_VALUE}px`,
};
